import React from "react";
import { Button } from "./button";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div>
      <h1>Route doesn't exist</h1>
      <Button onClick={() => navigate(`/`)}>Go home</Button>
    </div>
  );
};
